/**
 * Switches for parts of the inbox whose backing services are not everywhere yet.
 *
 * ★ SENDING MEDIA NEEDS THE CONNECTION LAYER'S UPLOAD ROUTE. The CRM proxies
 * an upload to `POST /api/whatsapp/channels/:channelId/media` on the
 * connection layer, which turns it into a Meta media id. On by default; a
 * deployment whose connection layer predates that route can set
 * `REACT_APP_WA_MEDIA_SEND=false` to hide the attach and microphone buttons
 * rather than offer a button whose only outcome is an error toast.
 */
export const MEDIA_SEND_ENABLED = String(process.env.REACT_APP_WA_MEDIA_SEND ?? 'true').toLowerCase() !== 'false';
